import { Component,  OnInit, ViewChild, Input } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { environment } from '@env/environment';
import { TranslateService } from '@ngx-translate/core';
import { SharedService } from '@shared/services/shared.service';
import { IAdministrativeComplaintView, IResponseLettersView, ISiteVisitModel } from 'app/models/mainMenu/mainMenu';
import { ComplaintService } from 'app/services/complaint/complaint.service';
import { MainMenuService } from 'app/services/mainMenu/mainMenu.service';

@Component({
  selector: 'app-accessibility-notice',
  templateUrl: './accessibilityNotice.component.html',
  styleUrls: ['./accessibilityNotice.component.scss']
})

export class AccessibilityNoticeComponent implements OnInit {
  public environment = environment;

  constructor(public mainMenu: MainMenuService,
    public complaintService: ComplaintService,
    private trans: TranslateService,
    private sharedService: SharedService
  ) { }

  ngOnInit(): void {


  }

}
